import type { MigrationStrategies } from "./_types/migration-strategies";

export const IMAGING_STUDY_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: (oldDoc) => oldDoc,
  2: (_) => null,
  3: (_) => null,
  // v4: patientId renamed to elephantPatientId (PNE-598), same value.
  4: ({ patientId, ...rest }) => ({
    ...rest,
    elephantPatientId: patientId ?? null,
  }),
};
